import { createApp } from 'vue';
import CommonPlugin from 'plugins/common-plugin';
import { i18n } from 'utils/i18n';
import store from 'stores/generic';

require('styles/pages/cleverreach-page.less');

const app = createApp();

app.use(CommonPlugin);
app.use(store);
app.use(i18n);

app.mount('#app');
